// src/config/api.config.js

// Check if we're running in development mode
// Vue CLI sets NODE_ENV to 'development' when running with 'npm run serve'
const isDevelopment = process.env.NODE_ENV === "development";

// Define API configuration based on environment
const API_CONFIG = {
  // Use localhost for development, domain for production
  baseUrl: isDevelopment
    ? "http://localhost:5000"
    : "https://api.yourcarllc.com",

  // You can add other API-related configurations here
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

// Export the config
export default API_CONFIG;
